import { green } from '@material-ui/core/colors';

const COLORS = {
  GREEN: '#005C29',
  TEXT: { DEFAULT: '#495057' },
  green,
};

const BACKGROUND_COLORS = {
  MAIN: '#f4f7fc',
  WHITE: '#fff',
  BLACK: '#000',
};

export const WEB_STYLES = { COLORS, BACKGROUND_COLORS };

export const APP_STYLES = {
  COLORS,
  BACKGROUND_COLORS,
};
